import { SubCategory } from './subCategory.model';
import { AttributeModel } from './attribute.model';
export class MainCategory {
    _id: string;
    mainCategoryName: string;
    mainCategoryDescription: string;
    mainCategoryImageName: string;
    mainCategoryNameError: boolean;
    status: string;
    subCategory: [SubCategory];
    attribute: [AttributeModel];
    urlLink: string;
}
